export const hasPrivilege = (profile: any, vgroup: string, code: string): boolean => {
  if (!profile?.data?.priviledges) {
    console.log('No privileges found in profile');
    return false;
  }

  const applicationType = profile?.data?.applicationType;
  if (applicationType === "Admin Transmora") {
    console.log(`Access granted for Admin Transmora application`);
    return true;
  }

  const hasAccess = profile.data.priviledges.some(
    (p: any) => p.vgroup === vgroup && p.code === code && p.applicationType === "Admin Transmora"
  );

  // console.log(`Privilege check: AdminTransmora.${vgroup}.${code} = ${hasAccess}`);
  return hasAccess;
};

export const hasAdminTransmoraAccess = (profile: any): boolean => {
  return profile?.data?.applicationType === "Admin Transmora";
};

export const hasPrivilegeWithApplication = (profile: any, vgroup: string, code: string): boolean => {
  return hasAdminTransmoraAccess(profile) || hasPrivilege(profile, vgroup, code);
};

export const hasDashboardAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'dashboard', action);

export const hasMonitorAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'monitor', 'view');

export const hasProjectAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'project', action);

export const hasClientAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'client', action);

export const hasPrincipalAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'principal', action);

export const hasStoreAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'store', action);

export const hasAreaAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'area', action);

export const hasGoodsAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'goods', action);

export const hasInstallerAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'installer', action);

export const hasUserAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'user', action);

export const hasRetailPartnerAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'merchant_partner', action);

export const hasFormAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'form', action);

export const hasRBACAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'role_access', action);

export const hasTagAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'tag', action);

export const hasOptionAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'option', action);

export const hasVersionAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'version', action);

export const hasBankAccountAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'amar_bank_account_registration', 'view');

export const hasQrisTransactionAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'amar_qris_transaction_status', 'view');

export const hasTimeDepositAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'amar_time_deposit_status', 'view');

export const hasTransferStatusAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'amar_transfer_status', 'view');

export const hasModuleAccess = (profile: any, vgroup: string) =>
  hasPrivilegeWithApplication(profile, vgroup, 'view');

export const hasTransactionAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'transaction', action);

export const hasReportEngineAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'report_engine', action);

export const hasSystemParameterAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'system_parameter', action);

export const hasSuspensionAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'suspension', action);

export const hasProjectConfigAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'client_project_config', action);

export const hasProjectKeyAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'client_project_key', action);

export const hasProjectLayoutAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'client_project_layout', action);

export const hasProjectFilterAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'client_project_filter', action);

export const hasProjectMetricAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'client_project_metric', action);

export const hasProjectUserAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'client_project_user', action);

export const hasHomeShortcutAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'home_shortcut', action);

export const hasPpobAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'ppob', action);

export const hasTribeAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'tribe', action);

export const hasPoiAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'poi', action);

export const hasStoreDirectorySupplyMonitorAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'store_directory_supply_monitor', action);

export const hasQCMonitorAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'monitor_qc', 'view');

export const hasUserGrowthMonitorAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'monitor_growth', 'view') || true;

export const hasCoverageAnalysisAccess = (profile: any) =>
  hasPrivilegeWithApplication(profile, 'monitor_growth', 'view') || true;

export const hasJobGroupTargetAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'project', action);

export const hasDistributionHubAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'distribution_hub', action);

export const hasNexusDistributorAccess = (profile: any, action: string = 'view') =>
  hasPrivilegeWithApplication(profile, 'nexus_distributor', action);